/* @flow */

import {
    type SuccessAction,
    type ErrorAction,
    type LoadingAction,
    type DestroyAction,
    type LoadingState,
    type Action,
} from './loading-types';
import { type State } from '../preact-app/types';

const INIT = 'loading/INIT';
const SUCCESS = 'loading/SUCCESS';
const ERROR = 'loading/ERROR';
const LOADING = 'loading/LOADING';
const DESTROY = 'loading/DESTROY';

export const success = (nome: string, mensagem?: string = ''): SuccessAction => ({
    type: SUCCESS,
    nome,
    mensagem,
});

export const error = (nome: string, mensagem?: string = ''): ErrorAction => ({
    type: ERROR,
    nome,
    mensagem,
});

export const loading = (nome: string, mensagem?: string = ''): LoadingAction => ({
    type: LOADING,
    nome,
    mensagem,
});

export const destroy = (): DestroyAction => ({
    type: DESTROY,
});

export const init = (etapas: Array<{ nome: string, mensagem: string }>) => ({
    type: INIT,
    etapas,
});

export const getLoading = (state: State) => state.loading;

const loadingReducer = (state: LoadingState = [], action: Action): LoadingState => {
    switch (action.type) {
    case INIT:
        return action.etapas.map(etapa => ({
            nome: etapa.nome,
            mensagem: etapa.mensagem,
            hasError: false,
            isSuccess: false,
            isLoading: false,
        }));
    case SUCCESS: {
        const { nome, mensagem } = action;
        return state.map(etapa => (etapa.nome !== nome ? etapa : ({
            nome: etapa.nome,
            mensagem: mensagem || etapa.mensagem,
            hasError: false,
            isSuccess: true,
            isLoading: false,
        })));
    }
    case ERROR: {
        const { nome, mensagem } = action;
        return state.map(etapa => (etapa.nome !== nome ? etapa : ({
            nome: etapa.nome,
            mensagem: mensagem || etapa.mensagem,
            hasError: true,
            isSuccess: false,
            isLoading: false,
        })));
    }
    case LOADING: {
        const { nome, mensagem } = action;
        return state.map(etapa => (etapa.nome !== nome ? etapa : ({
            nome: etapa.nome,
            mensagem: mensagem || etapa.mensagem,
            hasError: false,
            isSuccess: false,
            isLoading: true,
        })));
    }
    case DESTROY: {
        return [];
    }
    default:
        return state;
    }
};

export default loadingReducer;
